import { action, PayloadAction } from 'typesafe-actions';

import { UseFetchServiceErrors } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Anything } from '@types';

import { ServicesActionTypes, ServicesState } from './services.types';

export const saveSuccessServiceResponse = (data: ServicesState): PayloadAction<string, ServicesState> =>
	action(ServicesActionTypes.saveSuccessServiceResponse, data);

export const saveErrorServiceResponse = (
	error: UseFetchServiceErrors<Anything>
): PayloadAction<string, UseFetchServiceErrors<Anything>> =>
	action(ServicesActionTypes.saveErrorServiceResponse, error);
